import { render, staticRenderFns } from "./EventDetailsOverview.vue?vue&type=template&id=b8852a9c&scoped=true&"
import script from "./EventDetailsOverview.vue?vue&type=script&lang=ts&"
export * from "./EventDetailsOverview.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetailsOverview.vue?vue&type=style&index=0&id=b8852a9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8852a9c",
  null
  
)

export default component.exports